import { render, staticRenderFns } from "./editHome.vue?vue&type=template&id=e2e54dac&"
import script from "./editHome.vue?vue&type=script&lang=js&"
export * from "./editHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports